module.exports = __webpack_public_path__ + "img/y-102.e652b5f7.png";